import { __extends, __assign } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import TooltipInnerBody from './TooltipInnerBody.js';
import styles from './TooltipProviderStyles.module.scss.js';

var tooltipUniqueId = 'mk-react-tooltip-body';
var windowPadding = 20;
var TooltipWrapper = (function (_super) {
    __extends(TooltipWrapper, _super);
    function TooltipWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.needHorisontalFlip = false;
        _this.needVerticalFlip = false;
        _this.state = {
            isTooltipVisible: false,
            body: null,
            position: {
                x: 0,
                y: 0,
            },
        };
        _this._setRef = function (ref) {
            if (ref) {
                _this.Wrapper = ref;
            }
        };
        return _this;
    }
    TooltipWrapper.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (this.state.isTooltipVisible != nextState.isTooltipVisible ||
            this.state.position.x !== nextState.position.x ||
            this.state.position.y !== nextState.position.y);
    };
    TooltipWrapper.prototype._checkPosition = function () {
        var offset = {};
        if (this.Wrapper) {
            var element = document.getElementById(tooltipUniqueId);
            if (element) {
                var width = element.offsetWidth;
                var height = element.offsetHeight;
                var fullWidth = window.innerWidth;
                var fullHeight = window.innerHeight;
                var rightOffset = fullWidth - this.state.position.x - width - windowPadding;
                var bottomOffset = fullHeight - this.state.position.y - height - windowPadding;
                if (rightOffset <= 0) {
                    offset.marginLeft = rightOffset;
                }
                if (bottomOffset <= 0) {
                    offset.marginTop = -(-bottomOffset + windowPadding);
                }
            }
        }
        return offset;
    };
    TooltipWrapper.prototype.render = function () {
        var _a;
        return this.state.isTooltipVisible ? (React.createElement("div", { id: tooltipUniqueId, ref: this._setRef, className: classNames(styles.TooltipBody, (_a = this.props) === null || _a === void 0 ? void 0 : _a.className), style: __assign({ top: this.state.position.y, left: this.state.position.x }, this._checkPosition()), key: tooltipUniqueId }, this.state.body ? React.createElement(TooltipInnerBody, { content: this.state.body }) : null)) : null;
    };
    return TooltipWrapper;
}(React.Component));

export { TooltipWrapper as default, tooltipUniqueId, windowPadding };
//# sourceMappingURL=TooltipWrapper.js.map
